import React from "react";
import NavLink from "./NavLink";

export default class NavLinkInfo {
  constructor(name, label, route, auth) {
    this.name = name;
    this.label = label;
    this.route = route;
    this.auth = auth;
  }

  getLink(label) {
    return <NavLink label={label} link={this} />;
  }
}
